// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * store how far a document has been read by a user
 */
export interface DocumentProgressOutput {
  currentPage: unknown;
  totalPages: unknown;
}
